import { useTranslation } from "react-i18next"
import Loading from "components/commons/Loading"
import { useEditWorkerLeaveReportMutation, useGetWorkerLeaveReportQuery } from "../api/workContractApiSlice"
import LeaveReportTable from "../views/LeaveReportTable"
import Modal from "components/commons/Modal"
import { useEffect, useState } from "react"

export default function WorkerLeaveReport({
    userGUID,
    isEditable = false
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [editedValues, setEditedValues] = useState()

    console.log("EditedValues: " + JSON.stringify(editedValues))

    const {
        data: leaveReport,
        isSuccess,
        isError,
        isLoading,
        isFetching,
    } = useGetWorkerLeaveReportQuery(userGUID)

    const [
        editRequest, {
            isLoading: editIsLoading,
            isSuccess: editIsSuccess
        }
    ] = useEditWorkerLeaveReportMutation()

    function handleEdit() {
        editRequest(editedValues)
    }


    let content

    if (isSuccess) {
        content = <>
            <div className="mb-2">
                {
                    isEditable &&
                    <Modal
                        modalId={`user${userGUID}`}
                        buttonLabel={<> {t("action.adjust")}</>}
                        buttonIcon={<i className="fa-solid fa-pen-to-square"></i>}
                        buttonClass="btn btn-link text-accent btn-sm"
                        confirmStyle= "btn btn-primary"
                        isConfirm = {true}
                        body={<div className="text-start"><LeaveReportEditTable userGUID={userGUID} leaveReport={leaveReport} onEdit={setEditedValues} /></div>}
                        onConfirm={handleEdit}
                    />
                }

            </div>
            <LeaveReportTable leaveReport={leaveReport} showAvailability={true} />

        </>
    }

    if (isLoading || isFetching) {
        content = <Loading />
    }

    return content
}

function LeaveReportEditTable({
    userGUID,
    leaveReport,
    onEdit = () => { console.log("OnEdit Invoked!") } }) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const [holidaysAp, setHolidaysAp] = useState(leaveReport.holidays.ap)
    const [holidaysMatured, setHolidaysMatured] = useState(leaveReport.holidays.matured)

    const [timeOffAp, setTimeOffAp] = useState(leaveReport.timeOff.ap)
    const [timeOffMatured, setTimeOffMatured] = useState(leaveReport.timeOff.matured)

    const [abolishedAp, setAbolishedsAp] = useState(leaveReport.abolished.ap)
    const [abolishedMatured, setAbolishedMatured] = useState(leaveReport.abolished.matured)

    useEffect(() => {
        onEdit({
            userGuid: userGUID,
            holidays: {
                ap: holidaysAp,
                matured: holidaysMatured
            },
            timeOff: {
                ap: timeOffAp,
                matured: timeOffMatured
            },
            abolished: {
                ap: abolishedAp,
                matured: abolishedMatured
            }
        })
    }, [holidaysAp, holidaysMatured, timeOffAp, timeOffMatured, abolishedAp, abolishedMatured])

    return (
        <table className="table  table-hover  small">
            <tbody>
                <tr >
                    <td></td>
                    <td>{t("absenceReport:entity.leaveReport.property.prev_y")}</td>
                    <td>{t("absenceReport:entity.leaveReport.property.matured")}</td>
                </tr>
                <tr >
                    <td>{t("absenceReport:entity.leaveReport.type.holidays")}</td>
                    <td> <input type="number" className={`form-control ${holidaysAp == leaveReport.holidays.ap ? null : "bg-warning"}`} id="ha" value={holidaysAp} onChange={(e) => setHolidaysAp(e.target.value)} required /></td>
                    <td> <input type="number" className={`form-control ${holidaysMatured == leaveReport.holidays.matured ? null : "bg-warning"}`} id="hm" value={holidaysMatured} onChange={(e) => setHolidaysMatured(e.target.value)} required /></td>
                </tr>
                <tr >
                    <td>{t("absenceReport:entity.leaveReport.type.timeOff")}</td>
                    <td> <input type="number" className={`form-control ${timeOffAp == leaveReport.timeOff.ap ? null : "bg-warning"}`} id="ha" value={timeOffAp} onChange={(e) => setTimeOffAp(e.target.value)} required /></td>
                    <td> <input type="number" className={`form-control ${timeOffMatured == leaveReport.timeOff.matured ? null : "bg-warning"}`} id="hm" value={timeOffMatured} onChange={(e) => setTimeOffMatured(e.target.value)} required /></td>
                </tr>
                <tr >
                    <td>{t("absenceReport:entity.leaveReport.type.abolished")}</td>
                    <td> <input type="number" className={`form-control ${abolishedAp == leaveReport.abolished.ap ? null : "bg-warning"}`} id="ha" value={abolishedAp} onChange={(e) => setAbolishedsAp(e.target.value)} required /></td>
                    <td> <input type="number" className={`form-control ${abolishedMatured == leaveReport.abolished.matured ? null : "bg-warning"}`} id="hm" value={abolishedMatured} onChange={(e) => setAbolishedMatured(e.target.value)} required /></td>
                </tr>
            </tbody>
        </table>
    )
}